import { clientApi, serverApi, handleApiError } from "./index";

import type { AboutData } from "./types";

// About 데이터를 가져오는 함수 (클라이언트용)
export const fetchAboutData = async (): Promise<AboutData> => {
  try {
    const data = await clientApi.get<AboutData>("api/about");
    return data;
  } catch (error) {
    const apiError = handleApiError(error);
    throw new Error(`Failed to fetch about data: ${apiError.message}`);
  }
};

// About 데이터를 서버에서 가져오는 함수 (서버 컴포넌트용)
export const getAboutDataServer = async (): Promise<AboutData> => {
  try {
    const data = await serverApi.get<AboutData>("api/about");
    return data;
  } catch {
    // console.error("Error fetching about data:", error);
    return {
      title: "About Us",
      description: "Error loading data",
      team: [],
    };
  }
};

// 팀 멤버 관련 API 함수들
export const fetchTeamMembers = async () => {
  try {
    const aboutData = await fetchAboutData();
    return aboutData.team;
  } catch (error) {
    const apiError = handleApiError(error);
    throw new Error(`Failed to fetch team members: ${apiError.message}`);
  }
};

// 특정 팀 멤버 정보 가져오기
export const fetchTeamMember = async (id: number) => {
  try {
    const teamMembers = await fetchTeamMembers();
    const member = teamMembers.find(member => member.id === id);

    if (!member) {
      throw new Error(`Team member with id ${id} not found`);
    }

    return member;
  } catch (error) {
    const apiError = handleApiError(error);
    throw new Error(`Failed to fetch team member: ${apiError.message}`);
  }
};

// About 데이터 캐시 키
export const ABOUT_QUERY_KEYS = {
  all: ["about"] as const,
  data: () => [...ABOUT_QUERY_KEYS.all, "data"] as const,
  team: () => [...ABOUT_QUERY_KEYS.all, "team"] as const,
  member: (id: number) => [...ABOUT_QUERY_KEYS.team(), id] as const,
} as const;
